export let NEW_TRANSACTION_BUTTON = 'new-transaction-button';
export const PRODUCT_PRICES_TAB = 'price-tab';
export const PRODUCT_PRICES_TABLE = 'price-table';
export const NO_PRODUCT_PRICES = 'no-price';
